import { UseFormReturn } from "react-hook-form";
import { useState } from "react";
import { Step } from "./constants";
import { CaretLeft } from "@phosphor-icons/react";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { DrawerHeader } from "@/components/ui/drawer";
import { useTranslation } from "react-i18next";
import { InvoiceFormValues } from "./index";

const NoteStep = ({
  form,
  setStep,
}: {
  form: UseFormReturn<InvoiceFormValues>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation();
  const [note, setNote] = useState(form.getValues("description"));
  return (
    <div>
      <DrawerHeader
        title={t("label.add_note")}
        leftButton={
          <button type="button" onClick={() => setStep(Step.INITAL)}>
            <CaretLeft color="#E3EDFC" size={18} />
          </button>
        }
        rightButton={<span className="w-[18px]" />}
      />

      <Textarea
        data-testid="invoice-form-note-input"
        className="h-[200px]"
        placeholder={t("label.enter_note")}
        value={note}
        onChange={(e) => setNote(e.target.value)}
      />

      <Button
        data-testid="invoice-form-note-submit-button"
        className="mt-4 w-full"
        onClick={() => {
          form.setValue("description", note);
          setStep(Step.INITAL);
        }}
      >
        {t("button.add")}
      </Button>
    </div>
  );
};

export default NoteStep;
